import styled from 'styled-components';
import Alert from 'components/Alert';

export const MembersContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  align-content: flex-start;
`;

export const StyledAlert = styled(Alert)`
  max-width: 400px;
`;
